<template functional>
  <section class="satisfaction-guaranteed ws-grid">
    <div class="satisfaction-guaranteed__background"></div>
    <div class="satisfaction-guaranteed-content ws-col-7-gte600 ws-col-6-gte1440 ws-col-5-gte1920">
      <img
        class="satisfaction-guaranteed__logo"
        src="@/assets/images/satisfaction-guaranteed/satisfaction-logo.svg"
        alt=""
        loading="lazy"
      />

      <div>
        <h2
          class="satisfaction-guaranteed__title u-typography-helvetica u-text-display u-text-display--m"
        >
          {{ parent.$t('main.satisfactionGuaranteed') }}
        </h2>
        <p class="satisfaction-guaranteed__paragraph u-typography-helvetica u-text u-text--m">
          {{ parent.$t('section.yourTreatment.satisfactionGuaranteed.description.text') }}
        </p>

        <a
          class="satisfaction-guaranteed__link"
          :href="`https://skinxs.com/terms-of-sales/${parent.$i18n.locale}/article10`"
          target="_blank"
          >{{ parent.$t('common.conditionsApply.label') }}</a
        >
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'SatisfactionGuaranteedSection'
};
</script>

<style lang="scss" scoped>
.satisfaction-guaranteed {
  padding: 40px var(--ws-grid-m, 16px);
  height: 700px;
  position: relative;

  &__background {
    background-image: url(~@/assets/images/satisfaction-guaranteed/background/xs-min.jpg);
    background-repeat: no-repeat;
    background-size: cover;
    background-position: right;
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    z-index: -1;

    &:lang(ar) {
      transform: scaleX(-1);
    }
  }

  &__title,
  &__paragraph {
    margin-bottom: 16px;
  }

  &__logo {
    width: 48px;
    margin-bottom: 26px;
    flex: 0 0 auto;
  }

  &__link {
    font-family: var(--u-font-family-Gilroy);
    font-weight: 600;
    font-size: 11px;
    line-height: 18px;
    letter-spacing: 0.4px;
    text-decoration-line: underline;
    color: var(--u-color-grey-900);
  }
}

@media (-webkit-min-device-pixel-ratio: 2), (min-resolution: 192dpi) {
  /* retina */

  .satisfaction-guaranteed {
    &__background {
      background-image: url(~@/assets/images/satisfaction-guaranteed/background/xs-hd-min.jpg);
    }
  }
}

@media (min-width: 600px) {
  .satisfaction-guaranteed {
    padding-top: 64px;
    padding-bottom: 64px;
    height: 360px;

    &__background {
      background-image: url(~@/assets/images/satisfaction-guaranteed/background/m-min.jpg);
      background-position: center;
    }

    &__logo {
      margin-inline-end: 36px;
      margin-top: 10px;
    }
  }

  .satisfaction-guaranteed-content {
    display: flex;
    align-items: flex-start;
  }
}

@media (-webkit-min-device-pixel-ratio: 2) and (min-width: 600px),
  (min-resolution: 192dpi) and (min-width: 600px) {
  .satisfaction-guaranteed {
    &__background {
      background-image: url(~@/assets/images/satisfaction-guaranteed/background/m-hd-min.jpg);
    }
  }
}

@media (min-width: 1440px) {
  .satisfaction-guaranteed {
    &__background {
      background-image: url(~@/assets/images/satisfaction-guaranteed/background/l-min.jpg);
    }
  }
}

@media (-webkit-min-device-pixel-ratio: 2) and (min-width: 1440px),
  (min-resolution: 192dpi) and (min-width: 1440px) {
  .satisfaction-guaranteed {
    &__background {
      background-image: url(~@/assets/images/satisfaction-guaranteed/background/l-hd-min.jpg);
    }
  }
}
</style>
